import { Checkbox, Divider } from 'antd'
import Button from 'components/Button'
import Flex from 'components/Flex'
import Checkbox1 from 'components/Form/Checkbox'
import Input from 'components/Form/Input'
import Label from 'components/Form/Label'
import Radio from 'components/Form/RadioButton'
import Select from 'components/Select'
import SelectShort from 'components/Select/SelectShort'
import {
  FormHeading,
  FormItem,
  StyledInput,
} from 'components/UIComponents/FormStyles'
import { SecondGreyText } from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'
import { Spinner } from 'modules/Users/Style/style'
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { COLORS } from 'theme'
import { EmptyDivElement } from '../../../../../../components/UIComponents/CommonStyledComponent'
import {
  FlexWrap,
  RadioGroup,
  TypeGroup,
} from '../../../../../../components/UIComponents/FormStyles'
import NotificationsIcon from '../../../../../../components/icons/NotificationIcons'
import RightArrow from '../../../../../../components/icons/RightArrow'
import { systemConfig } from '../../../../../../utils/config'
import { isReturnBoolean } from '../../../../../../utils/rolecreationHelpers'
import {
  eligibilityCriteriaStepNum,
  getCoursesLabel,
  universalEduArr,
} from './CommonFunctions'
import MandatorySkills from './MandatorySkills'
import ScoreChart from './ScoreChart'
import ScoreDrawer from './ScoreDrawer'
import { ArrearSubText, MarginDiv, NoDataFound } from './Styles'
import './Styles.css'
import Skills from './skills'
export const StyledCheckbox = styled(Checkbox)`
  .ant-checkbox + span {
    padding-left: 12px;
    font-size: ${props => (props.headerSize ? '12px' : '13px')};
    font-weight: ${props => (props.fontWeight ? props.fontWeight : '400')};
    text-transform: ${props => (props.headerSize ? 'uppercase' : 'capitalize')};
  }
  // .ant-checkbox-inner {
  //   width: 12px !important;
  //   height: 12px !important;
  //   border-radius: 3px !important;
  // }

  // .ant-checkbox-input {
  //   margin-bottom: 10px !important;
  // }
  // &.ant-checkbox-wrapper {
  //   align-items: flex-start !important;
  // }
  // .ant-checkbox {
  //   margin-top: 2px !important;
  // }
  margin-right: 8px;

  &.ant-checkbox-wrapper {
    .ant-checkbox {
      .ant-checkbox-inner {
        border-color: ${props =>
          props.checked || props.indeterminate ? COLORS.PRIMARY : '#D0D5DD'};
        background-color: ${props =>
          props.checked ? COLORS.PRIMARY : 'white'};
      }

      &.ant-checkbox-indeterminate .ant-checkbox-inner::after {
        background-color: ${COLORS.PRIMARY};
      }
    }
  }
`

const SearchSelectionItems = [
  {
    id: 1,
    label: 'Degree',
    value: 'ALL',
  },
  {
    id: 2,
    label: 'Dept.',
    value: 'STREAM',
  },
  {
    id: 3,
    label: 'Spec.',
    value: 'SPECIALISATION',
  },
  // {
  //   id: 4,
  //   label: 'Test',
  //   value: 'TEST',
  // },
]

const ArrowIcon = ({ expanded }) => (
  <div
    style={{
      transform: expanded ? 'rotate(90deg)' : 'rotate(0deg)',
      transition: 'transform 0.3s ease',
      display: 'flex',
      alignItems: 'center',
      color: COLORS.GREY_T_60,
    }}
  >
    <RightArrow width={'12px'} height={'12px'} />
  </div>
)

const EligibilityCriteria = ({
  roleFormData,
  setRoleFormData,
  scoreError,
  setScoreError,
  marksValue,
  setMarksValue,
  scoreType,
  setScoreType,
  singleRoleData,
  isEditingRole,
  listOfSkills,
  setListOfSkills,
  listOfOptionalSkills,
  getSpecialisationList,
  specialisationList,
  roleForm,
  setSkillSearch,
  skillsCount,
  isFieldsMandatory,
  skillLoading,
  setSave,
  Form,
  criteriaCall,
  setSelectedData,
  updateIsSelected,
  setSelectedType,
  selectedType,
  eligibleCandidatesMetrics,
  getDegreeData,
  degreeList,
  setQualificationError,
  mandatoryTypeError,
  setMandatoryTypeError,
  editData,
  qualificationError,
  checkAllCompleted,
  confirmLoading,
  draft,
  jobEligibilityForm,
  getMasterSearchApi,
  currentStep,
  stepStatus,
  triggerBack,
  criteriaBasedCurrentCourse,
  criteriaTypes,
  skillSearch,
  setArrowExpand,
  setPreviewData,
  previewData,
  selectedSkills,
  setSelectedSkills,
  mandatorySkillsIds,
  setMandatorySkillsIds,
  skillsManuallyModified,
  setSkillsManuallyModified,
}) => {
  const [openScoreDrawer, setOpenScoreDrawer] = useState(false)
  const [scoreValue, setScoreValue] = useState(0)
  const [yearOptions, setYearOptions] = useState([])
  const [skillsSetOpen, setSkillsSetOpen] = useState(false)
  const [notFoundedMandatorySkills, setNotFoundedMandatorySkills] = useState([])
  const [notFoundedSecondarySkills, setNotFoundedSecondarySkills] = useState([])
  const tableRefs = useRef([])
  const [selectedIndex, setSelectedIndex] = useState(0)
  const defaultSelectedData = async (completeData, selectedSection) => {
    const newData = await completeData?.map(degree => {
      const selectedDegrees = selectedSection?.filter(
        sd => sd.degreeId === degree.degreeId
      )
      if (selectedDegrees?.length > 0) {
        degree.isSelected = true

        // Process streams and specialisations for all matching degrees
        degree.streams = degree?.streams?.map(stream => {
          const selectedStreams = selectedDegrees
            .flatMap(selectedDegree => selectedDegree.streams)
            .filter(ss => ss.streamId === stream.streamId)

          if (selectedStreams?.length > 0) {
            stream.isSelected = true

            stream.specialisations = stream?.specialisations?.map(
              specialisation => {
                const isSpecialisationSelected = selectedStreams.some(
                  selectedStream =>
                    selectedStream.specialisations?.some(
                      selectedSpecialisation =>
                        selectedSpecialisation.specialisationId ===
                        specialisation.specialisationId
                    )
                )

                if (isSpecialisationSelected) {
                  specialisation.isSelected = true
                }

                return specialisation
              }
            )
          }

          return stream
        })
      }

      return degree
    })

    return newData
  }
  const loadCriteriaData = async (
    searchValue = '',
    searchType = 'ALL',
    searchField = 'UG'
  ) => {
    await criteriaCall({
      searchValue: searchValue,
      searchType: searchType,
      searchField: searchField,
    })
  }
  useEffect(() => {
    getSpecialisationList({
      streamIds: [],
    })
    loadCriteriaData()
  }, [])

  const populateSkillValue = async (skills, type) => {
    if (skills?.length) {
      let notFoundMandatorySkills = []
      let notFoundSecondarySkills = []
      for (const element of skills) {
        let payLoad = systemConfig.skills
        payLoad.q = element?.toString()
        const data = await getMasterSearchApi('skills', payLoad)
        if (data?.length) {
          if (data?.length == 1) {
            if (type == 'mandatorySkills') {
              const existingSkills =
                roleFormData?.mandatorySkills?.primary?.skills || []
              if (!existingSkills?.includes(data[0]?.id)) {
                existingSkills.push(data[0]?.id)
              }
              roleFormData.mandatorySkills.primary = {
                ...roleFormData.mandatorySkills?.primary,
                skills: existingSkills,
              }
              roleForm.setFieldValue(
                ['mandatorySkills', 'primary', 'skills'],
                existingSkills
              )
            } else if (type == 'secondarySkills') {
              setSkillsSetOpen(true)
              const existingSkills =
                roleFormData?.mandatorySkills?.mandatory || []
              if (!existingSkills.includes(data[0]?.id)) {
                existingSkills.push(data[0]?.id)
              }
              roleFormData.mandatorySkills.mandatory = existingSkills
              roleForm.setFieldValue(
                ['mandatorySkills', 'mandatory'],
                existingSkills
              )
            }
          } else {
            const exactMatch = data.find(skill => {
              if (skill?.name.toLowerCase() == element?.trim()?.toLowerCase()) {
                return skill
              }
            })
            if (type == 'mandatorySkills') {
              if (exactMatch) {
                const existingSkills =
                  roleFormData?.mandatorySkills?.primary?.skills || []
                if (!existingSkills?.includes(exactMatch?.id)) {
                  existingSkills.push(exactMatch?.id)
                }
                roleFormData.mandatorySkills.primary = {
                  ...roleFormData.mandatorySkills?.primary,
                  skills: existingSkills,
                }
                roleForm.setFieldValue(
                  ['mandatorySkills', 'primary', 'skills'],
                  existingSkills
                )
              }
            }
            if (type == 'secondarySkills') {
              setSkillsSetOpen(true)
              if (exactMatch) {
                const existingSkills =
                  roleFormData?.mandatorySkills?.mandatory || []
                if (!existingSkills?.includes(exactMatch?.id)) {
                  existingSkills.push(exactMatch?.id)
                }
                roleFormData.mandatorySkills.mandatory = existingSkills
                roleForm.setFieldValue(
                  ['mandatorySkills', 'mandatory'],
                  existingSkills
                )
              }
            }
          }
        } else {
          if (type == 'secondarySkills') {
            notFoundSecondarySkills.push(element)
          } else if (type == 'mandatorySkills') {
            notFoundMandatorySkills.push(element)
          }
        }
      }
      setNotFoundedMandatorySkills(notFoundMandatorySkills)
      setNotFoundedSecondarySkills(notFoundSecondarySkills)
    }
  }
  useLayoutEffect(() => {
    if (
      jobEligibilityForm != {} &&
      !stepStatus?.qualification &&
      !triggerBack
    ) {
      // if (
      //   Array.isArray(jobEligibilityForm?.Compulsory_Skills) &&
      //   jobEligibilityForm?.Compulsory_Skills?.length
      // ) {
      //   populateSkillValue(
      //     jobEligibilityForm?.Compulsory_Skills,
      //     'mandatorySkills'
      //   )
      // }
      // let skillSet2List = []
      // if (
      //   Array.isArray(jobEligibilityForm?.Optional_Skills) &&
      //   jobEligibilityForm?.Optional_Skills?.length
      // ) {
      //   skillSet2List.push(jobEligibilityForm?.Optional_Skills)
      // }
      // if (
      //   Array.isArray(jobEligibilityForm?.Secondary_Skills) &&
      //   jobEligibilityForm?.Secondary_Skills?.length
      // ) {
      //   skillSet2List.push(jobEligibilityForm?.Secondary_Skills)
      // }
      // if (skillSet2List?.length) {
      //   populateSkillValue(skillSet2List, 'secondarySkills')
      // }

      if (jobEligibilityForm?.Score?.YearOfPassing) {
        const yearList = Array.isArray(jobEligibilityForm?.Score?.YearOfPassing)
          ? jobEligibilityForm?.Score?.YearOfPassing
          : jobEligibilityForm?.Score?.YearOfPassing?.split(',')
        if (yearList?.length) {
          const numberYearList = yearList.map(item => Number(item))
          roleFormData.yearOfPassing = numberYearList
          roleForm.setFieldValue(['yearOfPassing'], numberYearList)
        }
      }
      if (jobEligibilityForm?.Score?.isArrearsAllowed == 1) {
        roleFormData.isArrearsAllowed = true
        roleForm.setFieldValue(['isArrearsAllowed'], true)
        if (jobEligibilityForm?.Score?.arrearCount) {
          roleFormData.arrearCount.count =
            Number(jobEligibilityForm?.Score?.arrearCount) || 0
          roleForm.setFieldValue(
            ['arrearCount', 'count'],
            Number(jobEligibilityForm?.Score?.arrearCount) || 0
          )
        }
      } else {
        roleFormData.isArrearsAllowed = false
        roleForm.setFieldValue(['isArrearsAllowed'], false)
      }
      let tenthScore = 0
      let twelfthScore = 0

      if (jobEligibilityForm?.Score?.['10th']) {
        const score = jobEligibilityForm?.Score?.['10th'] || ''
        tenthScore = Number(String(score).replace('%', '').trim()) || 0
        roleFormData.scores.tenth = tenthScore
        roleForm.setFieldValue(['scores', 'tenth'], tenthScore)
      }

      if (jobEligibilityForm?.Score?.['12th']) {
        const score = jobEligibilityForm?.Score?.['12th'] || ''
        twelfthScore = Number(String(score).replace('%', '').trim()) || 0
        roleFormData.scores.twelfth = twelfthScore
        roleForm.setFieldValue(['scores', 'twelfth'], twelfthScore)
      }

      if (tenthScore == twelfthScore) {
        setScoreType('Average')
      } else {
        setScoreType('Custom')
      }
    }
  }, [jobEligibilityForm])

  useEffect(() => {
    const years = []
    for (let i = 2000; i <= new Date().getFullYear() + 5; i++) {
      years.push({
        value: i,
        name: i.toString()
      })
    }
    setQualificationError('')
    setYearOptions(years?.slice()?.reverse())
    getDegreeData('getAllCourses=true')
  }, [])

  useEffect(() => {
    setPreviewData(prevState => ({
      ...prevState,
      avgScore: roleFormData?.scores?.avg || null,
      tenthScore: roleFormData?.scores?.tenth || null,
      twelfthScore: roleFormData?.scores?.twelfth || null,
      UGScore: roleFormData?.scores?.UG || null,
      PGScore: roleFormData?.scores?.PG || null,
      UGDiplomaScore: roleFormData?.scores?.UGDiploma || null,
      PGDiplomaScore: roleFormData?.scores?.UGDiploma || null,
    }))
  }, [roleFormData.scores])

  const scoreTypeOptions = [
    {
      name: 'Average',
      value: 'Average',
    },
    {
      name: 'Custom',
      value: 'Custom',
    },
  ]

  const handleScoreChange = e => {
    setScoreType(e.target.value)
    setRoleFormData(prevState => ({
      ...prevState,
      scores: {
        ...prevState?.scores,
        avg: 0,
        tenth: 0,
        twelfth: 0,
        UG: 0,
        PG: 0,
        UGDiploma: 0,
      },
    }))
  }

  const marksValidator = data => {
    setSave(false)
    const {
      tenth: tenthValue,
      twelfth: twelfthValue,
      UG: ugMarksValue,
      PG: pgMarksValue,
    } = data

    const isValidNumber =
      /^(\d+)?(\.\d{0,2})?$/.test(tenthValue) &&
      /^(\d+)?(\.\d{0,2})?$/.test(twelfthValue) &&
      /^(\d+)?(\.\d{0,2})?$/.test(ugMarksValue) &&
      /^(\d+)?(\.\d{0,2})?$/.test(pgMarksValue)

    const isValidRange =
      tenthValue >= 30 &&
      tenthValue <= 100 &&
      twelfthValue >= 30 &&
      twelfthValue <= 100 &&
      ugMarksValue >= 30 &&
      ugMarksValue <= 100 &&
      pgMarksValue >= 30 &&
      pgMarksValue <= 100

    if (!isFieldsMandatory) {
      roleForm.setFields([
        {
          name: ['scores'],
          errors: [''],
        },
      ])
      return Promise.resolve()
    }

    if (!isValidNumber || !isValidRange) {
      roleForm.setFields([
        {
          name: ['scores'],
          errors: ['The score should be between 30 to 100'],
        },
      ])
    } else {
      roleForm.setFields([
        {
          name: ['scores'],
          errors: [''],
        },
      ])
      return Promise.resolve()
    }
  }

  const onChangeHandler = (value, key) => {
    setSave(false)
    setRoleFormData(prevState => ({
      ...prevState,
      [key]: value,
    }))
    roleForm?.setFieldsValue({
      ...roleForm,
      [key]: value,
    })

    setPreviewData(prevState => ({
      ...prevState,
      [key]: value,
    }))
    if (['yearOfPassing']?.includes(key)) {
      let data = {
        ...roleFormData,
        [key]: value,
      }
      eligibleCandidatesMetrics(data)
    }
  }
  const updatePreviewMandatorySkillNames = (
    key,
    value,
    newArr,
    type = 'skills'
  ) => {
    setPreviewData(prev => {
      const current = prev?.mandatorySkillNames ?? {}

      const transformSkillNames = arr =>
        arr?.map(item => ({
          id: item?.option?.id,
          name: item?.option?.name,
          status: Number(item?.option?.status),
        })) ?? []

      let updated = { ...current }

      if (type === 'skills') {
        // === PRIMARY SKILLS ===
        if (key === 'primary') {
          updated.primarySkillNames = {
            type:
              Array.isArray(value) && value.length === 0
                ? ''
                : roleFormData?.mandatorySkills?.primary?.type ?? 'OR',
            skills: Array.isArray(value) ? [...value] : [],
            skillNames: transformSkillNames(newArr),
          }
        }

        // === MANDATORY SKILLS ===
        else if (key === 'mandatory') {
          updated.mandatorySkillNames = transformSkillNames(newArr)
          updated.mandatoryCount =
            Array.isArray(value) && value.length > 0
              ? roleFormData?.mandatorySkills?.mandatoryCount ?? 0
              : 0
        }

        // === MANDATORY COUNT ===
        else if (key === 'mandatoryCount') {
          updated.mandatoryCount = value
        }
      }

      // === PRIMARY TYPE UPDATE ONLY ===
      else if (type === 'type' && key === 'primary') {
        updated.primarySkillNames = {
          ...(current.primarySkillNames ?? { skills: [], skillNames: [] }),
          type: value, // value is 'AND' or 'OR'
        }
      }

      return {
        ...prev,
        mandatorySkillNames: updated,
      }
    })
  }

  const onChangeMandatorySkills = (value, key, type, newArr) => {
    setSave(false)

    updatePreviewMandatorySkillNames(key, value, newArr, type)
    type = type ?? 'skills'
    if (type == 'skills') {
      if (key === 'primary') {
        setRoleFormData({
          ...roleFormData,
          mandatorySkills: {
            ...(roleFormData.mandatorySkills
              ? roleFormData.mandatorySkills
              : {}),
            primary: {
              ...(roleFormData.mandatorySkills
                ? roleFormData.mandatorySkills
                : {}
              ).primary,
              skills: value,
              skillNames: newArr?.map(item => item?.name),
              type:
                value?.length === 0
                  ? ''
                  : roleFormData.mandatorySkills?.primary?.type,
            },
          },
        })
        roleForm?.setFieldsValue({
          mandatorySkills: {
            ...(roleFormData.mandatorySkills
              ? roleFormData.mandatorySkills
              : {}),
            primary: {
              ...(roleFormData.mandatorySkills
                ? roleFormData.mandatorySkills
                : {}
              ).primary,
              skills: value,
              skillNames: newArr?.map(item => item?.name),
              type:
                value?.length === 0
                  ? ''
                  : roleFormData.mandatorySkills?.primary?.type,
            },
          },
        })
        let data = {
          ...roleFormData,
          mandatorySkills: {
            ...(roleFormData.mandatorySkills
              ? roleFormData.mandatorySkills
              : {}),
            primary: {
              ...(roleFormData.mandatorySkills
                ? roleFormData.mandatorySkills
                : {}
              ).primary,
              skills: value,
              skillNames: newArr?.map(item => item?.name),
              type:
                value?.length === 0
                  ? ''
                  : roleFormData.mandatorySkills?.primary?.type,
            },
          },
        }
        setNotFoundedMandatorySkills([])
        eligibleCandidatesMetrics(data)
      } else if (key === 'mandatory') {
        setRoleFormData({
          ...roleFormData,
          mandatorySkills: {
            ...(roleFormData.mandatorySkills
              ? roleFormData.mandatorySkills
              : {}),
            mandatory: value,
            mandatorySkillName: newArr?.map(item => item?.name),
            mandatoryCount:
              value?.length > 0
                ? roleFormData?.mandatorySkills?.mandatoryCount
                : 0,
          },
        })
        roleForm?.setFieldsValue({
          mandatorySkills: {
            ...(roleFormData.mandatorySkills
              ? roleFormData.mandatorySkills
              : {}),
            mandatory: value,
            mandatorySkillName: newArr?.map(item => item?.name),
            mandatoryCount:
              value?.length > 0
                ? roleFormData?.mandatorySkills?.mandatoryCount
                : 0,
          },
        })
        let data = {
          ...roleFormData,
          mandatorySkills: {
            ...(roleFormData.mandatorySkills
              ? roleFormData.mandatorySkills
              : {}),
            mandatory: value,
            mandatorySkillName: newArr?.map(item => item?.name),
            mandatoryCount:
              value?.length > 0
                ? roleFormData?.mandatorySkills?.mandatoryCount
                : 0,
          },
        }

        setNotFoundedSecondarySkills([])
        eligibleCandidatesMetrics(data)
      } else if (key === 'mandatoryCount') {
        setRoleFormData({
          ...roleFormData,
          mandatorySkills: {
            ...(roleFormData.mandatorySkills
              ? roleFormData.mandatorySkills
              : {}),
            mandatoryCount: value,
          },
        })
        roleForm?.setFieldsValue({
          mandatorySkills: {
            ...(roleFormData.mandatorySkills
              ? roleFormData.mandatorySkills
              : {}),
            mandatoryCount: value,
          },
        })
        let data = {
          ...roleFormData,
          mandatorySkills: {
            ...(roleFormData.mandatorySkills
              ? roleFormData.mandatorySkills
              : {}),
            mandatoryCount: value,
          },
        }
        eligibleCandidatesMetrics(data)
      }
    } else if (key === 'primary') {
      setMandatoryTypeError(false)
      setRoleFormData({
        ...roleFormData,
        mandatorySkills: {
          ...(roleFormData.mandatorySkills ? roleFormData.mandatorySkills : {}),
          primary: {
            ...(roleFormData?.mandatorySkills?.primary
              ? roleFormData.mandatorySkills?.primary ?? { skills: [] }
              : { skills: [] }),
            type: value,
          },
        },
      })
      roleForm?.setFieldsValue({
        mandatorySkills: {
          ...(roleFormData.mandatorySkills ? roleFormData.mandatorySkills : {}),
          primary: {
            ...(roleFormData?.mandatorySkills?.primary
              ? roleFormData.mandatorySkills?.primary ?? { skills: [] }
              : { skills: [] }),
            type: value,
          },
        },
      })
      let data = {
        ...roleFormData,
        mandatorySkills: {
          ...(roleFormData.mandatorySkills ? roleFormData.mandatorySkills : {}),
          primary: {
            ...(roleFormData?.mandatorySkills?.primary
              ? roleFormData.mandatorySkills?.primary ?? { skills: [] }
              : { skills: [] }),
            type: value,
          },
        },
      }
      eligibleCandidatesMetrics(data)
    } else if (key === 'otherSkills') {
      let data = [
        ...(roleFormData?.mandatorySkills?.otherSkills?.length
          ? roleFormData?.mandatorySkills?.otherSkills ?? [
              { type: '', skills: [] },
            ]
          : [{ type: '', skills: [] }]),
      ]
      // data[index]['type'] = value
      setRoleFormData({
        ...roleFormData,
        mandatorySkills: {
          ...(roleFormData.mandatorySkills ? roleFormData.mandatorySkills : {}),
          otherSkills: data,
        },
      })
      roleForm?.setFieldsValue({
        mandatorySkills: {
          ...(roleFormData.mandatorySkills ? roleFormData.mandatorySkills : {}),
          otherSkills: data,
        },
      })
    }
    setSkillSearch('')
  }

  const handleDropdownVisibleChange = open => {
    if (!open) {
      setSkillSearch('')
    }
  }

  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }

  function addIsSelectedField(data, action) {
    return data?.map(domain => {
      return {
        ...domain,
        isSelected: false, // Replace "value" with the desired value or logic
        isExpanded: action,
        streams: domain.streams.map(stream => {
          return {
            ...stream,
            streamName: stream?.streamName?.toString()?.toLowerCase(),
            isSelected: false, // Replace "value" with the desired value or logic
            isExpanded: action,
            specialisations: stream.specialisations.map(specialisation => {
              return {
                ...specialisation,
                isSelected: false, // Replace "value" with the desired value or logic
                specialisationName: specialisation?.specialisationName
                  ?.toString()
                  ?.toLowerCase(),
              }
            }),
          }
        }),
      }
    })
  }

  const checkedData = (
    index,
    value,
    field,
    degreeId,
    departmentId,
    specialisationId,
    isExpanded
  ) => {
    let data = {
      index,
      field,
      isSelected: value,
      id: degreeId,
      departmentId,
      specId: specialisationId,
      isExpanded,
    }
    if (field == 'degree' || field == 'stream' || field == 'specialisation') {
      if (typeof isExpanded === 'boolean') {
        setArrowExpand(data)
      } else {
        updateIsSelected(data)
      }
    } else {
      updateIsSelected(data)
    }
  }

  const TableComponent = ({
    selectedData,
    indexKey,
    selectedKey,
    type,
    checkAllCompleted,
  }) => {
    return (
      <table className="custom-table">
        <thead>
          <tr style={{ border: '1px solid gray' }}>
            <th style={{ width: '10%' }}>
              <StyledCheckbox
                checked={
                  selectedData?.length > 0 &&
                  selectedData?.every(degree => degree?.isSelected)
                }
                indeterminate={
                  selectedData?.some(degree => degree?.isSelected) &&
                  !selectedData?.every(degree => degree?.isSelected)
                }
                fontWeight={500}
                headerSize={true}
                onChange={({ target }) => {
                  checkedData(indexKey, target?.checked, 'allDegree')
                }}
                disabled={checkAllCompleted}
              >
                {' '}
                {type == 'DIPLOMA' ? 'DIPLOMA' : 'DEGREE'}
              </StyledCheckbox>
            </th>

            <th style={{ width: '45%' }}>
              <StyledCheckbox
                fontWeight={500}
                headerSize={true}
                checked={selectedData
                  ?.filter(
                    item =>
                      Array.isArray(item.streams) && item.streams.length > 0
                  ) // Check if streams exists and has length > 0
                  ?.map(item => item.streams)
                  ?.flat()
                  ?.every(stream => stream?.isSelected)}
                indeterminate={
                  selectedData
                    ?.map(item => item.streams)
                    ?.flat()
                    ?.some(stream => stream?.isSelected) &&
                  !selectedData
                    ?.map(item => item.streams)
                    ?.flat()
                    ?.every(stream => stream?.isSelected)
                }
                onChange={({ target }) => {
                  checkedData(indexKey, target?.checked, 'allStream')
                }}
                disabled={checkAllCompleted}
              >
                {' '}
                DEPARTMENT
              </StyledCheckbox>
            </th>

            <th style={{ width: '45%' }}>
              <StyledCheckbox
                checked={
                  selectedData
                    ?.map(item => item?.streams)
                    ?.flat()
                    ?.map(degree => degree?.specialisations)
                    ?.flat()
                    ?.filter(spec => spec)?.length > 0 && // Filter out empty or undefined specialisations // Check that specialisations array is not empty
                  selectedData
                    ?.map(item => item?.streams)
                    ?.flat()
                    ?.map(degree => degree?.specialisations)
                    ?.flat()
                    ?.every(spec => spec?.isSelected)
                }
                indeterminate={
                  selectedData
                    ?.map(item => item?.streams)
                    ?.flat()
                    ?.map(degree => degree?.specialisations)
                    ?.flat()
                    ?.some(spec => spec?.isSelected) &&
                  !selectedData
                    ?.map(item => item?.streams)
                    ?.flat()
                    ?.map(degree => degree?.specialisations)
                    ?.flat()
                    ?.every(spec => spec?.isSelected)
                }
                fontWeight={500}
                headerSize={true}
                onChange={({ target }) => {
                  checkedData(indexKey, target?.checked, 'allSpec')
                }}
                disabled={checkAllCompleted}
              >
                {' '}
                SPECIALIZATION
              </StyledCheckbox>
            </th>
          </tr>
        </thead>
        <tbody
          id={`tableId-eligible${indexKey}`}
          ref={el => (tableRefs.current[indexKey] = el)}
        >
          {selectedData?.map(degree => (
            <React.Fragment key={degree.degreeId}>
              <tr>
                <td>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <StyledCheckbox
                      disabled={checkAllCompleted}
                      checked={degree?.isSelected}
                      fontWeight={600}
                      onChange={({ target }) => {
                        checkedData(
                          indexKey,
                          target?.checked,
                          'degree',
                          degree.degreeId
                        )
                      }}
                    >
                      {degree.degreeShortForm}
                    </StyledCheckbox>
                    <div
                      onClick={() => {
                        checkedData(
                          indexKey,
                          undefined,
                          'degree',
                          degree.degreeId,
                          undefined,
                          undefined,
                          !degree?.isExpanded
                        )
                      }}
                      style={{
                        cursor: 'pointer',
                        marginRight: '8px',
                        // pointerEvents: searchTerm ? 'none' : 'auto'
                      }}
                    >
                      <ArrowIcon expanded={degree?.isExpanded} />
                    </div>
                  </div>
                  {/* )} */}
                </td>
                <td></td>
                <td></td>
              </tr>

              {degree.isExpanded && degree.streams.map(stream => (
                  <React.Fragment key={stream.streamId}>
                    <tr>
                      <td
                        style={{
                          paddingLeft: '2.5em',
                          color: '#c0c0c0',
                          fontSize: 'smaller',
                        }}
                      >
                        {degree.degreeShortForm}
                      </td>
                      <td>
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                          }}
                        >
                          <StyledCheckbox
                            checked={stream?.isSelected}
                            disabled={checkAllCompleted}
                            onChange={({ target }) => {
                              checkedData(
                                indexKey,
                                target?.checked,
                                'stream',
                                degree.degreeId,
                                stream.streamId
                              )
                            }}
                          >
                            {stream.streamName}
                          </StyledCheckbox>
                          {stream?.specialisations?.length > 0 && (
                            <div
                              onClick={() => {
                                checkedData(
                                  indexKey,
                                  undefined,
                                  'stream',
                                  degree.degreeId,
                                  stream.streamId,
                                  undefined,
                                  !stream?.isExpanded
                                )
                              }}
                              style={{
                                cursor: 'pointer',
                                marginRight: '8px',
                                // pointerEvents: searchTerm ? 'none' : 'auto'
                              }}
                            >
                              <ArrowIcon expanded={stream?.isExpanded} />
                            </div>
                          )}
                        </div>
                      </td>
                      <td></td>
                    </tr>
                    {stream.isExpanded && stream.specialisations?.map(
                        (specialisation, specialisationIndex) => (
                          <tr key={specialisationIndex}>
                            <td
                              style={{
                                paddingLeft: '2.5em',
                                color: '#c0c0c0',
                                fontSize: 'smaller',
                              }}
                            >
                              {degree.degreeShortForm}
                            </td>
                            <td
                              style={{
                                paddingLeft: '2.5em',
                                color: '#c0c0c0',
                                fontSize: 'smaller',
                                textTransform: 'capitalize',
                              }}
                            >
                              {stream.streamName}
                            </td>
                            <td>
                              {' '}
                              <StyledCheckbox
                                disabled={checkAllCompleted}
                                checked={specialisation?.isSelected}
                                onChange={({ target }) => {
                                  checkedData(
                                    indexKey,
                                    target?.checked,
                                    'specialisation',
                                    degree.degreeId,
                                    stream?.streamId,
                                    specialisation?.specialisationId
                                  )
                                }}
                              >
                                {specialisation.specialisationName}
                              </StyledCheckbox>
                            </td>
                          </tr>
                        )
                      )}
                  </React.Fragment>
                ))}
            </React.Fragment>
          ))}
        </tbody>
      </table>
    )
  }
  const onChangeType = async (field, index, value) => {
    const currentValues = roleForm.getFieldValue('qualityCriteria')
    // Preserve the search value when switching between degree/department tabs
    const currentSearchValue = currentValues?.[index]?.search || ''
    
    console.log('🔍 Tab Switch Debug:', {
      field,
      index,
      value,
      currentSearchValue,
      currentValues: currentValues?.[index]
    });
    
    // Don't clear search - preserve it completely
    const updatedValues = currentValues.map((item, idx) =>
      idx === index ? { ...item } : item
    )
    roleForm.setFieldsValue({ qualityCriteria: updatedValues })

    setSelectedType(prevSelectedType => {
      let isUpdated = false
      const updatedArray = prevSelectedType.map(data => {
        // If the same key exists, update the object with the new data
        if (data?.key === index) {
          isUpdated = true
          return {
            ...data,
            field: field,
            key: index,
            value: value,
          }
        }
        // If the same value exists, reset the previous object's field and value to ""
        if (data?.value === value) {
          return {
            ...data,
            field: '',
            value: '',
          }
        }
        // Otherwise, return the object unchanged
        return data
      })
      // If no object with the matching key was found, add the new object
      if (!isUpdated) {
        updatedArray.push({
          field: field,
          key: index,
          value: value,
        })
      }

      return updatedArray
    })
    // If there's an existing search value, use it to maintain search results
    const searchResult = await onSearchQualification(
      currentSearchValue,
      'ALL',
      value,
      index,
      true
    )

    setRoleFormData(prevData => {
      const newQualityCriteria = prevData.qualityCriteria.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            toSearch: 'ALL',
            data: searchResult || [],
            type: Object.keys(item.selected).filter(
              key =>
                item.selected[key]?.data?.length > 0 ||
                item.selected[key]?.isAllDegree
            ),
          }
        }
        return item
      })

      return { ...prevData, qualityCriteria: newQualityCriteria }
    })
    setSelectedIndex(index)
  }

  const onAddCriteria = index => {
    let qualityCriteria = {
      type: [],
      allSelect: false,
      search: '',
      data: [],
      selected: {
        UG: { isAllDegree: false, data: [] },
        PG: { isAllDegree: false, data: [] },
        DIPLOMA: { isAllDegree: false, data: [] },
      },
    }

    setRoleFormData(prevData => {
      const newQualityCriteriaArray = [
        ...prevData.qualityCriteria,
        qualityCriteria,
      ]

      const updatedQualityCriteriaArray = newQualityCriteriaArray.map(
        (item, i) => {
          if (i === index) {
            return {
              ...item,
              toSearch: 'ALL',
              type: Object.keys(item.selected).filter(
                key =>
                  item.selected[key]?.data?.length > 0 ||
                  item.selected[key]?.isAllDegree
              ),
            }
          }
          return item
        }
      )

      const totalTypes = updatedQualityCriteriaArray
        ?.map(item => item.type)
        ?.flat()
        ?.filter(item => item !== '')
      const updatedQualityCriteriaArrayWithTypes = newQualityCriteriaArray.map(
        (item, i) => {
          if (i === index) {
            return {
              ...item,
              toSearch: 'ALL',
              type: Object.keys(item.selected).filter(
                key =>
                  item.selected[key]?.data?.length > 0 ||
                  item.selected[key]?.isAllDegree
              ),
              totalTypes: totalTypes,
            }
          } else {
            return { ...item, totalTypes: totalTypes }
          }
        }
      )
      return {
        ...prevData,
        qualityCriteria: updatedQualityCriteriaArrayWithTypes,
      }
    })
  }

  const onSearchQualification = async (
    searchValue,
    searchType,
    searchField,
    index,
    isReturn = false,
    isOpen = false
  ) => {
    let result = []
    if (index === 0) {
      const searchFieldArr =
        searchField === 'DIPLOMA' ? ['DIPLOMA', 'P_G_DIPLOMA'] : [searchField]
      result = await criteriaBasedCurrentCourse({
        searchValue: searchValue ?? '',
        searchType: searchType,
        searchField: searchFieldArr ?? [criteriaTypes[0]],
      })
    } else {
      result = await criteriaCall({
        searchValue: searchValue ?? '',
        searchType: searchType ?? 'ALL',
        searchField: searchField ?? 'UG',
        callEndPoint: index === 0,
      })
    }

    const updatedDataForSelection = await addIsSelectedField(
      result,
      searchValue ? true : false
    )

    const mergeSelectedDataToAutoSelect = await defaultSelectedData(
      updatedDataForSelection,
      roleFormData?.qualityCriteria?.[index]?.selected?.[searchField ?? 'UG']
        ?.data
    )
    if (isReturn) {
      return mergeSelectedDataToAutoSelect
    } else {
      setRoleFormData(prevData => {
        const newQualityCriteria = prevData.qualityCriteria.map((item, i) => {
          if (i === index) {
            return {
              ...item,
              data: mergeSelectedDataToAutoSelect,
            }
          }
          return item
        })
        return { ...prevData, qualityCriteria: newQualityCriteria }
      })
    }
  }
  const onSearchValue = debounce(
    (search, index, searchField, selected, toSearch) => {
      onSearchQualification(search, toSearch, searchField, index, false, true)
    },
    1000
  )
  const onClickSearchSelection = (index, value, selectedType) => {
    console.log('🔍 Search Selection Debug:', {
      index,
      value,
      selectedType,
      currentSearch: roleForm.getFieldValue('qualityCriteria')?.[index]?.search
    });
    
    setRoleFormData(prevData => {
      const newQualityCriteria = prevData.qualityCriteria.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            toSearch: value,
          }
        }
        return item
      })
      return { ...prevData, qualityCriteria: newQualityCriteria }
    })
    
    // Always trigger search with current search value, even if empty
    let search = roleForm.getFieldValue('qualityCriteria')?.[index]?.search || ''
    console.log('🔍 Triggering search with:', { search, value, selectedType });
    onSearchQualification(search, value, selectedType, index)
  }
  const isAllChecked = (index, value, field) => {
    setQualificationError('')
    setRoleFormData(prevData => {
      const newQualityCriteria = prevData.qualityCriteria.map((item, i) => {
        if (i === index) {
          return {
            ...item,
            selected: {
              ...item.selected,
              [field]: {
                ...item.selected?.[field],
                isAllDegree: value,
              },
            },
          }
        }
        return item
      })
      const finalDataWithType = newQualityCriteria.map((item, i) => {
        if (i === index) {
          return {
            ...item,

            type: Object.keys(item.selected).filter(
              key =>
                item.selected[key]?.data?.length > 0 ||
                item.selected[key]?.isAllDegree
            ),
          }
        }
        return item
      })
      const totalTypes = finalDataWithType
        ?.map(item => item.type)
        ?.flat()
        ?.filter(item => item !== '')
      const updatedQualityCriteriaArrayWithTypes = finalDataWithType.map(
        (item, i) => {
          if (i === index) {
            return {
              ...item,
              type: Object.keys(item.selected).filter(
                key =>
                  item.selected[key]?.data?.length > 0 ||
                  item.selected[key]?.isAllDegree
              ),
              totalTypes: totalTypes,
            }
          } else {
            return { ...item, totalTypes: totalTypes }
          }
        }
      )

      return {
        ...prevData,
        qualityCriteria: updatedQualityCriteriaArrayWithTypes,
      }
    })
  }
  const onClickClearAll = (index, field) => {
    console.log('🔍 Clear All Debug - START:', { index, field });
    
    // Reset isSelected flags on all degrees, streams, and specializations
    setRoleFormData(prevData => {
      const newQualityCriteria = [...prevData.qualityCriteria].map((item, i) => {
        if (i === index) {
          console.log('🔍 Resetting isSelected flags for index', index);
          
          // Deep clone and reset all isSelected flags
          const resetData = item.data?.map(degree => ({
            ...degree,
            isSelected: false,
            streams: degree.streams?.map(stream => ({
              ...stream,
              isSelected: false,
              specialisations: stream.specialisations?.map(spec => ({
                ...spec,
                isSelected: false
              }))
            }))
          })) || [];
          
          console.log('🔍 Reset data:', resetData);
          console.log('🔍 First degree isSelected:', resetData[0]?.isSelected);
          
          return {
            ...item,
            type: item.type?.filter(t => t !== field),
            totalTypes: item.totalTypes?.filter(t => t !== field),
            data: resetData,
            selected: {
              ...item.selected,
              [field]: { isAllDegree: false, data: [] },
            },
            _updateKey: Date.now(), // Force re-render key
          }
        } else {
          return {
            ...item,
            totalTypes: item.totalTypes?.filter(t => t !== field),
          }
        }
      })
      
      const updatedData = { ...prevData, qualityCriteria: newQualityCriteria };
      console.log('🔍 Updated roleFormData after clear:', updatedData.qualityCriteria[index]);
      console.log('🔍 Updated data array:', updatedData.qualityCriteria[index].data);
      return updatedData;
    })
    
    // Force re-render by updating form values
    const currentValues = roleForm.getFieldValue('qualityCriteria')
    const currentSearchValue = currentValues?.[index]?.search || ''
    
    // Add a timestamp to force re-render
    const updatedValues = currentValues.map((item, idx) =>
      idx === index ? { ...item, search: currentSearchValue, _clearTimestamp: Date.now() } : item
    )
    roleForm.setFieldsValue({ qualityCriteria: updatedValues })
    
    // Debug: Check state after 1 second
    setTimeout(() => {
      console.log('🔍 State check after 1 second:', {
        dataFirstDegree: roleFormData?.qualityCriteria?.[index]?.data?.[0],
        selectedData: roleFormData?.qualityCriteria?.[index]?.selected?.[field]?.data
      });
    }, 1000);
    
    console.log('🔍 Clear All Debug - END');
  }
  const onFloatingDegreeChange = (e, option) => {
    roleForm?.setFieldsValue({
      roleFlotedTo: e,
    })
    setRoleFormData({
      ...roleFormData,
      roleFlotedTo: e,
    })
  }

  useEffect(() => {
    if (criteriaTypes?.length > 0) {
      let value = roleFormData?.qualityCriteria[0]?.type[0] || criteriaTypes[0]
      setSelectedType([{ field: 'type', key: 0, value: value }])
      onSearchQualification('', 'ALL', value, 0)
    } else {
      if (currentStep === eligibilityCriteriaStepNum)
        setQualificationError('Please map course')
    }
  }, [criteriaTypes, currentStep])

  return (
    <>
      {confirmLoading ? (
        <Flex center>
          <Spinner />
        </Flex>
      ) : (
        <>
          <FormHeading>Eligibility Criteria</FormHeading>
          <FormItem name={'qualityCriteria'} initialValue={[]}>
            <Label style={{ fontSize: '14px' }}>Qualification *</Label>
            {criteriaTypes?.length === 0 ? (
              <div
                style={{
                  fontSize: '14px',
                  color: 'red',
                  fontWeight: '400',
                }}
              >
                {'Please map course'}
              </div>
            ) : (
              <Form.List name="qualityCriteria">
                {(fields, { add, remove }, { errors }) => (
                  <>
                    {roleFormData?.qualityCriteria?.map(
                      (
                        { type, search, data, selected, toSearch, totalTypes },
                        index,
                        roleCriteriaArr
                      ) => {
                        return (
                          <>
                            <Form.Item
                              name={[index, 'type']}
                              style={{ marginBottom: '0px' }}
                            >
                              <TypeGroup width="150px">
                                {universalEduArr(criteriaTypes, index)?.map(
                                  (item, i, arr) => {
                                    console.log('🔍 Button Render Debug:', {
                                      item,
                                      index,
                                      criteriaTypes,
                                      buttonLabel: item.label
                                    });
                                    const isDataExists =
                                      selected[
                                        selectedType?.find(
                                          r => r?.value === item?.value
                                        )?.value
                                      ]?.data?.length > 0 ||
                                      selected[
                                        selectedType?.find(
                                          r => r?.value === item?.value
                                        )?.value
                                      ]?.isAllDegree
                                    return (
                                      <EmptyDivElement
                                        key={i}
                                        style={{
                                          display: 'flex',
                                          alignItems: 'center',
                                          pointerEvents: isDataExists
                                            ? 'none'
                                            : totalTypes
                                                ?.filter(
                                                  item =>
                                                    !type?.includes?.(item)
                                                )
                                                ?.includes(item.value)
                                            ? 'none'
                                            : '',
                                        }}
                                        onClick={() => {
                                          console.log('🔍 Button Click Debug:', {
                                            item: item.value,
                                            index,
                                            roleStatus: roleFormData?.roleStatus,
                                            republishedDate: roleFormData?.republishedDate,
                                            conditionResult: !isReturnBoolean(
                                              roleFormData?.roleStatus,
                                              undefined,
                                              roleFormData?.republishedDate
                                            )
                                          });
                                          
                                          if (
                                            !isReturnBoolean(
                                              roleFormData?.roleStatus,
                                              undefined,
                                              roleFormData?.republishedDate
                                            )
                                          ) {
                                            onChangeType(
                                              'type',
                                              index,
                                              item.value
                                            )
                                          }
                                        }}
                                      >
                                        <Label
                                          style={{
                                            margin: '1em',
                                            border: type?.includes(item.value)
                                              ? '1px solid #3249D7'
                                              : '1px solid gainsboro',
                                            borderRadius: '10px',
                                            padding: '1em 1.5em',
                                            height: '3.5em',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'center',
                                            letterSpacing: '0.1em',
                                            width: '9em',
                                            justifyContent: 'center',
                                            background:
                                              selectedType?.find(
                                                r => r?.key === index
                                              )?.value === item?.value
                                                ? ' #3249D7'
                                                : isDataExists
                                                ? '#f0f0f0'
                                                : totalTypes
                                                    ?.filter(
                                                      item =>
                                                        !type?.includes?.(item)
                                                    )
                                                    ?.includes(item.value)
                                                ? '#f0f0f0'
                                                : '#fff',
                                            color:
                                              selectedType?.find(
                                                r => r?.key === index
                                              )?.value === item?.value
                                                ? 'white'
                                                : 'black',
                                          }}
                                        >
                                          {item.label}
                                        </Label>
                                        {i < arr?.length - 1 ? (
                                          <Label>OR</Label>
                                        ) : (
                                          '  '
                                        )}
                                      </EmptyDivElement>
                                    )
                                  }
                                )}
                              </TypeGroup>
                              {
                                <div
                                  style={{
                                    fontSize: '14px',
                                    color: 'red',
                                    fontWeight: '400',
                                  }}
                                >
                                  {qualificationError}
                                </div>
                              }
                            </Form.Item>

                            {selectedType?.find(r => r?.key === index)?.key ===
                              index && selectedIndex === index ? (
                              <>
                                <div
                                  style={{
                                    display: 'flex',
                                    justifyContent: 'flex-start',
                                    alignItems: 'center',
                                    margin: '1em 0',
                                  }}
                                >
                                  <div style={{}}>
                                    <Checkbox
                                      disabled={
                                        isReturnBoolean(
                                          roleFormData?.roleStatus,
                                          undefined,
                                          roleFormData?.republishedDate
                                        ) || checkAllCompleted
                                      }
                                      checked={
                                        selected?.[
                                          selectedType?.find(
                                            r => r?.key === index
                                          )?.value
                                        ]?.isAllDegree
                                      }
                                      fontWeight={600}
                                      onChange={({ target }) => {
                                        const fieldValue = selectedType?.find(
                                          r => r?.key === index
                                        )?.value
                                        
                                        if (target?.checked) {
                                          isAllChecked(index, true, fieldValue)
                                        } else {
                                          onClickClearAll(index, fieldValue)
                                        }
                                      }}
                                    >
                                      <Label color="black">
                                        {' '}
                                        Select all degree under{' '}
                                        {getCoursesLabel(
                                          selectedType?.find(
                                            r => r?.key === index
                                          )?.value
                                        )}
                                      </Label>
                                    </Checkbox>
                                  </div>
                                </div>
                                {!selected?.[
                                  selectedType?.find(r => r?.key === index)
                                    ?.value
                                ]?.isAllDegree && (
                                  <>
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center',
                                        marginBottom: '8px',
                                      }}
                                    >
                                      <Label>Search using keywords</Label>
                                      <EmptyDivElement
                                        style={{
                                          cursor: !isReturnBoolean(
                                            roleFormData?.roleStatus,
                                            undefined,
                                            roleFormData?.republishedDate
                                          )
                                            ? 'pointer'
                                            : 'default',
                                        }}
                                        onClick={() => {
                                          if (
                                            !isReturnBoolean(
                                              roleFormData?.roleStatus,
                                              undefined,
                                              roleFormData?.republishedDate
                                            )
                                          ) {
                                            // Clear search input first
                                            const currentValues = roleForm.getFieldValue('qualityCriteria')
                                            const updatedValues = currentValues.map((item, idx) =>
                                              idx === index ? { ...item, search: '' } : item
                                            )
                                            roleForm.setFieldsValue({ qualityCriteria: updatedValues })
                                            
                                            // Clear all selections - this will reset isSelected flags
                                            onClickClearAll(
                                              index,
                                              selectedType?.find(
                                                r => r?.key === index
                                              )?.value
                                            )
                                          }
                                        }}
                                      >
                                        <Label color="red">Clear All</Label>
                                      </EmptyDivElement>
                                    </div>
                                    <div>
                                      <Form.Item>
                                        <Input
                                          name={[index, 'search']}
                                          type="text"
                                          style={{ fontWeight: '600' }}
                                          width="100%"
                                          placeholder="Search using keywords"
                                          value={roleForm.getFieldValue('qualityCriteria')?.[index]?.search || ''}
                                          onChange={({ target }) => {
                                            const currentValues = roleForm.getFieldValue('qualityCriteria')
                                            const updatedValues = currentValues.map((item, idx) =>
                                              idx === index ? { ...item, search: target.value } : item
                                            )
                                            roleForm.setFieldsValue({ qualityCriteria: updatedValues })
                                            
                                            onSearchValue(
                                              target.value,
                                              index,
                                              selectedType?.find(
                                                r => r?.key === index
                                              )?.value,
                                              selected,
                                              toSearch
                                            )
                                          }}
                                          disabled={isReturnBoolean(
                                            roleFormData?.roleStatus,
                                            undefined,
                                            roleFormData?.republishedDate
                                          )}
                                        />
                                      </Form.Item>
                                    </div>

                                    <div
                                      style={{
                                        height:
                                          tableRefs.current?.[index]?.childNodes
                                            ?.length < 8
                                            ? 'auto'
                                            : '30em',
                                        overflow: 'auto',
                                        border: '1px solid #e2e2e2',
                                        boxShadow: '0px 0px 5px 1px #bfd3ff',
                                        borderRadius: '5px',
                                        margin: '1em 0em',
                                      }}
                                    >
                                      {data?.length > 0 ? (
                                        <TableComponent
                                          indexKey={index}
                                          selectedData={data}
                                          data={data}
                                          type={
                                            selectedType?.find(
                                              r => r?.key === index
                                            )?.value
                                          }
                                          checkAllCompleted={checkAllCompleted}
                                        />
                                      ) : (
                                        roleForm.getFieldValue(
                                          'qualityCriteria'
                                        )?.[index]?.search?.length > 0 && (
                                          <NoDataFound>
                                            <div style={{ color: 'dimgray' }}>
                                              No Data Found
                                            </div>
                                          </NoDataFound>
                                        )
                                      )}
                                    </div>
                                  </>
                                )}
                                {selectedType?.find(r => r?.key === index)
                                  ?.value === 'PG' && (
                                  <FlexWrap
                                    margintop="8px"
                                    flexWrap
                                    marginLeft="-10px"
                                  >
                                    <div>
                                      <NotificationsIcon />
                                    </div>
                                    <SecondGreyText
                                      color="#3249D7"
                                      paddingTop="3px"
                                    >
                                      Note : PGDM/PGDBM choose under PG.
                                    </SecondGreyText>
                                  </FlexWrap>
                                )}
                                {selectedType?.find(r => r?.key === index)
                                  ?.value === 'DIPLOMA' && (
                                  <FlexWrap
                                    margintop="8px"
                                    flexWrap
                                    marginLeft="-10px"
                                  >
                                    <div>
                                      <NotificationsIcon />
                                    </div>
                                    <SecondGreyText
                                      color="#3249D7"
                                      paddingTop="3px"
                                    >
                                      Note : PGDM/PGDBM choose under DIPLOMA.
                                    </SecondGreyText>
                                  </FlexWrap>
                                )}

                                <>
                                  {totalTypes?.length <= 3 && (
                                    <>
                                      {fields.length == index + 1 &&
                                        fields?.length < 3 && (
                                          <FlexWrap
                                            flexWrap
                                            onClick={() => {
                                              if (
                                                !isReturnBoolean(
                                                  roleFormData?.roleStatus,
                                                  undefined,
                                                  roleFormData?.republishedDate
                                                )
                                              ) {
                                                add()
                                                onAddCriteria(index)
                                              }
                                            }}
                                            style={{ cursor: 'pointer' }}
                                          >
                                            <Button.Secondary
                                              text='+ Add "And"'
                                              color
                                              backgroundColor="rgb(255, 255, 255)"
                                              disabled={isReturnBoolean(
                                                roleFormData?.roleStatus,
                                                undefined,
                                                roleFormData?.republishedDate
                                              )}
                                            />
                                            <FlexWrap margintop="8px" flexWrap>
                                              <div>
                                                <NotificationsIcon />
                                              </div>
                                              <SecondGreyText
                                                color="#3249D7"
                                                paddingTop="3px"
                                              >
                                                Note : Use the “And” option to
                                                add a combination.
                                              </SecondGreyText>
                                            </FlexWrap>
                                          </FlexWrap>
                                        )}
                                    </>
                                  )}
                                </>
                              </>
                            ) : null}

                            {roleCriteriaArr?.length - 1 > index && (
                              <div
                                style={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  fontWeight: '600',
                                }}
                              >
                                <Divider>AND</Divider>
                              </div>
                            )}
                          </>
                        )
                      }
                    )}
                  </>
                )}
              </Form.List>
            )}
          </FormItem>
        <div style={{ position: "relative" }}>
          <Skills
            skillList={listOfSkills}
            handleSearch={value => setSkillSearch(value)}
            selectedSkills={selectedSkills}
            setSelectedSkills={(skills) => {
              setSelectedSkills(skills)
              setSkillsManuallyModified(true)
              console.log('Skills manually modified - flag set to true')
            }}
            mandatorySkillsIds={mandatorySkillsIds}
            setMandatorySkillsIds={setMandatorySkillsIds}
            setPreviewData={setPreviewData}
            previewData={previewData}
            eligibleCandidatesMetrics={eligibleCandidatesMetrics}
            roleFormData={roleFormData}
            // skillLoading={skillLoading}
            // getListOfSkills={getListOfSkills}
            // disabled={publishDisabled}
          />

          {isReturnBoolean(roleFormData?.roleStatus, undefined, roleFormData?.republishedDate) && (
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "transparent",
              cursor: "not-allowed",
              zIndex: 10,
            }}
          />
        )}
      </div>
          {skillLoading && (
            <div>
              <FormItem name={['optionalSkills']}>
                <Select
                  OptionData={listOfOptionalSkills?.filter(
                    skill =>
                      !roleFormData?.mandatorySkills?.mandatory?.includes(
                        skill?.id
                      ) &&
                      !roleFormData?.mandatorySkills?.primary?.skills?.includes(
                        skill?.id
                      ) &&
                      !roleFormData?.mandatorySkills?.otherSkills?.some(
                        otherSkill => otherSkill?.skills?.includes(skill?.id)
                      )
                  )}
                  label="Optional skills"
                  valueParam="id"
                  showSearch={true}
                  placeholder="Select Skills"
                  showArrow={true}
                  mode="multiple"
                  onChange={value => onChangeHandler(value, 'optionalSkills')}
                  onSearch={value => setSkillSearch(value)}
                  optionFilterProp="name"
                  customOptions={roleFormData?.republishedDate ?? false}
                  selectedOptions={singleRoleData?.optionalSkills}
                  onDropdownVisibleChange={handleDropdownVisibleChange}
                  allowClear={roleFormData?.republishedDate ?? false}
                  disabled={isReturnBoolean(
                    roleFormData?.roleStatus,
                    undefined,
                    roleFormData?.republishedDate
                  )}
                />
              </FormItem>
              {roleFormData?.optionalSkills?.length ? (
                <Flex right>
                  <Label>
                    {roleFormData?.optionalSkills?.length}/{skillsCount}
                  </Label>
                </Flex>
              ) : null}
            </div>
          )}
          <FormItem
            name={['yearOfPassing']}
            rules={[
              {
                required: !draft,
                message: 'Please select year',
              },
            ]}
          >
            <Label>Year of Passing*</Label>
            <Select
              name={['yearOfPassing']}
              style={{ borderRadius: '5px', width: '100%' }}
              showArrow={true}
              OptionData={yearOptions}
              valueParam="value"
              nameParam="name"
              placeholder="Select year"
              mode="multiple"
              value={roleFormData?.yearOfPassing ?? []}
              onChange={value => onChangeHandler(value, 'yearOfPassing')}
              showSearch={true}
              autoClearSearchValue={true}
              allowClear={roleFormData?.republishedDate ?? false}
              selectedPlaceId={'yearOfPassing'}
              listHeight={170}
              customOptions={roleFormData?.republishedDate ?? false}
              selectedOptions={editData?.yearOfPassing ?? []}
              disabled={isReturnBoolean(
                roleFormData?.roleStatus,
                undefined,
                roleFormData?.republishedDate
              )}
            />
          </FormItem>
          <FormItem name={['roleFlotedTo']}>
            <Label>
              If you want to share this role with other students in your
              college, select degrees to share the role.
            </Label>
            <SelectShort
              name={['roleFlotedTo']}
              valueParam={'id'}
              placeholder="Eg. Bachlore of Engineering - B.E"
              OptionData={degreeList.filter(
                option => option.status.toString() === '1'
              )}
              onChange={onFloatingDegreeChange}
              shortForm={true}
              iskey={true}
              mode={'multiple'}
              value={roleFormData?.roleFlotedTo ?? []}
              allowClear={true}
              listHeight={170}
              disabled={isReturnBoolean(
                roleFormData?.roleStatus,
                undefined,
                roleFormData?.republishedDate
              )}
            />
          </FormItem>
          <div>
            <Label>Score ( Percentage )</Label>
            <div>
              <Label style={{ color: '#9a9a9a' }}>
                If any students scored below this score, they are not eligible
                to apply
              </Label>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap' }}>
              <RadioGroup
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
                value={scoreType}
              >
                {scoreTypeOptions.map((item, scoreIndex) => {
                  return (
                    <Label
                      key={scoreIndex}
                      style={{
                        border: '1px solid gainsboro',
                        borderRadius: '10px',
                        padding: '2em 1.5em',
                        height: '3em',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        letterSpacing: '0.1em',
                        backgroundColor: '#ffffff',
                        justifyContent: 'center',
                      }}
                    >
                      <Radio
                        label={item.name}
                        value={item?.value}
                        onChange={handleScoreChange}
                        disabled={isReturnBoolean(
                          roleFormData?.roleStatus,
                          undefined,
                          roleFormData?.republishedDate
                        )}
                      />
                    </Label>
                  )
                })}
              </RadioGroup>
            </div>
          </div>
          <FormItem name={['scores']}>
            <ScoreChart
              setPreviewData={setPreviewData}
              tenthValue={roleFormData?.scores?.tenth}
              twelfthValue={roleFormData?.scores?.twelfth}
              ugMarksValue={roleFormData?.scores?.UG}
              pgMarksValue={roleFormData?.scores?.PG}
              setScoreValue={setScoreValue}
              scoreValue={scoreValue}
              setMarksValue={setMarksValue}
              setRoleFormData={setRoleFormData}
              roleFormData={roleFormData}
              selectedCourses={
                roleFormData?.qualityCriteria?.[0]?.totalTypes || []
              }
              marksValue={marksValue}
              isFieldsMandatory={isFieldsMandatory}
              setScoreError={setScoreError}
              scoreError={scoreError}
              scoreType={scoreType}
              eligibleCandidatesMetrics={eligibleCandidatesMetrics}
              marksValidator={marksValidator}
              roleForm={roleForm}
              disabled={isReturnBoolean(
                roleFormData?.roleStatus,
                undefined,
                roleFormData?.republishedDate
              )}
            />
            <div
              style={{
                fontSize: '14px',
                color: 'red',
                fontWeight: '400',
              }}
            >
              {scoreError}
            </div>
          </FormItem>

          <div>
            <Label>Arrears / Backlogs *</Label>

            <MarginDiv>
              <FormItem
                name={['isArrearsAllowed']}
                // rules={[
                //   {
                //     required: false, // Check the flag
                //     message: 'Please enter the bond type',
                //   },
                // ]}
              >
                <Checkbox1
                  onChange={
                    event => {
                      setRoleFormData({
                        ...roleFormData,
                        isArrearsAllowed: event.target.checked,
                        arrearCount: {
                          ...roleFormData.arrearCount,
                          count: 0,
                        },
                      })
                      setPreviewData({
                        ...previewData,
                        isArrearsAllowed: event.target.checked,
                        arrearCount: 0,
                      })
                      roleForm.setFieldValue(
                        ['isArrearsAllowed'],
                        event.target.checked
                      )
                      roleForm.setFieldValue(['arrearCount', 'count'], 0)
                      let data = {
                        ...roleFormData,
                        isArrearsAllowed: event.target.checked,
                      }
                      eligibleCandidatesMetrics(data)
                    }
                    //  onChangeHandlerCTC(event.target.checked, 'isBond')
                  }
                  label={'Allow current arrears'}
                  checked={roleFormData?.isArrearsAllowed}
                  disabled={isReturnBoolean(
                    roleFormData?.roleStatus,
                    undefined,
                    roleFormData?.republishedDate
                  )}
                />
              </FormItem>
              <ArrearSubText>Any arrears that are not cleared</ArrearSubText>
            </MarginDiv>
            {roleFormData?.isArrearsAllowed && (
              <MarginDiv>
                <Label>Enter no. of current arrears*</Label>
                <StyledInput
                  type="number"
                  width="50%"
                  name={['arrearCount', 'count']}
                  placeholder="00"
                  defaultValue={roleFormData?.arrearCount?.count}
                  rules={[
                    () => ({
                      validator(_, value) {
                        const enteredValue = Number(value)
                        if (isNaN(enteredValue)) {
                          return Promise.reject(
                            new Error('Please enter a valid number')
                          )
                        }
                        if (!value || /^0+$/.test(value)) {
                          return Promise.reject(
                            new Error('Please enter a valid number')
                          )
                        }
                        if (enteredValue < 0) {
                          return Promise.reject(
                            new Error('Please enter a positive number')
                          )
                        }
                        if (value > 40) {
                          return Promise.reject(
                            new Error(`Must be less than 40`)
                          )
                        }

                        if (
                          roleFormData?.republishedDate &&
                          Number(value) < Number(singleRoleData?.arrearCount)
                        ) {
                          return Promise.reject(
                            new Error(
                              `Must be greater than ${singleRoleData?.arrearCount}`
                            )
                          )
                        }
                        return Promise.resolve()
                      },
                    }),
                  ]}
                  onChange={({ target }) => {
                    setRoleFormData({
                      ...roleFormData,
                      arrearCount: {
                        ...roleFormData.arrearCount,
                        count: Number(target?.value),
                      },
                    })
                    setPreviewData({
                      ...previewData,
                      arrearCount: Number(target?.value),
                    })
                    let data = {
                      ...roleFormData,
                      arrearCount: {
                        ...roleFormData.arrearCount,
                        count: Number(target?.value),
                      },
                    }
                    eligibleCandidatesMetrics(data)
                  }}
                  onKeyPress={e =>
                    [' ', '.']?.includes(e.key) && e.preventDefault()
                  }
                  disabled={isReturnBoolean(
                    roleFormData?.roleStatus,
                    undefined,
                    roleFormData?.republishedDate
                  )}
                />
              </MarginDiv>
            )}
            <MarginDiv>
              <FormItem
                name={['isHistoryArrears']}
                // rules={[
                //   {
                //     required: false, // Check the flag
                //     message: 'Please enter the bond type',
                //   },
                // ]}
              >
                <Checkbox1
                  onChange={
                    event => {
                      setRoleFormData({
                        ...roleFormData,
                        isHistoryArrears: event.target.checked,
                        historyArrearCount: {
                          ...roleFormData.historyArrearCount,
                          count: 0,
                        },
                      })
                      setPreviewData({
                        ...previewData,
                        isHistoryArrears: event.target.checked,
                        historyArrearCount: 0,
                      })
                      roleForm.setFieldValue(
                        ['isHistoryArrears'],
                        event.target.checked
                      )
                      roleForm.setFieldValue(['historyArrearCount', 'count'], 0)

                      let data = {
                        ...roleFormData,
                        isHistoryArrears: event.target.checked,
                      }
                      eligibleCandidatesMetrics(data)
                    }
                    //  onChangeHandlerCTC(event.target.checked, 'isBond')
                  }
                  label={'Allow history of arrears'}
                  checked={roleFormData?.isHistoryArrears}
                  disabled={isReturnBoolean(
                    roleFormData?.roleStatus,
                    undefined,
                    roleFormData?.republishedDate
                  )}
                />
              </FormItem>
              <ArrearSubText>
                Any arrears of the past that are cleared
              </ArrearSubText>
            </MarginDiv>

            {roleFormData?.isHistoryArrears && (
              <MarginDiv>
                <Label>Enter no. of history of arrears*</Label>
                <StyledInput
                  type="number"
                  width="50%"
                  name={['historyArrearCount', 'count']}
                  placeholder="00"
                  defaultValue={roleFormData?.historyArrearCount?.count}
                  rules={[
                    () => ({
                      validator(_, value) {
                        const enteredValue = Number(value)
                        if (isNaN(enteredValue)) {
                          return Promise.reject(
                            new Error('Please enter a valid number')
                          )
                        }
                        if (!value || /^0+$/.test(value)) {
                          return Promise.reject(
                            new Error('Please enter a valid number')
                          )
                        }
                        if (enteredValue < 0) {
                          return Promise.reject(
                            new Error('Please enter a positive number')
                          )
                        }
                        if (value > 40) {
                          return Promise.reject(
                            new Error(`Must be less than 40`)
                          )
                        }

                        if (
                          roleFormData?.republishedDate &&
                          Number(value) <
                            Number(singleRoleData?.historyArrearCount)
                        ) {
                          return Promise.reject(
                            new Error(
                              `Must be greater than ${singleRoleData?.historyArrearCount}`
                            )
                          )
                        }
                        return Promise.resolve()
                      },
                    }),
                  ]}
                  onChange={({ target }) => {
                    setRoleFormData({
                      ...roleFormData,
                      historyArrearCount: {
                        ...roleFormData.historyArrearCount,
                        count: Number(target?.value),
                      },
                    })
                    setPreviewData({
                      ...previewData,
                      historyArrearCount: Number(target?.value),
                    })
                    let data = {
                      ...roleFormData,
                      historyArrearCount: {
                        ...roleFormData.historyArrearCount,
                        count: Number(target?.value),
                      },
                    }
                    eligibleCandidatesMetrics(data)
                  }}
                  onKeyPress={e =>
                    [' ', '.']?.includes(e.key) && e.preventDefault()
                  }
                  disabled={isReturnBoolean(
                    roleFormData?.roleStatus,
                    undefined,
                    roleFormData?.republishedDate
                  )}
                />
              </MarginDiv>
            )}
            <MarginDiv>
              <FormItem>
                <Checkbox1
                  onChange={
                    event => {
                      setRoleFormData({
                        ...roleFormData,
                        isHistoryArrears: false,
                        isArrearsAllowed: false,
                        historyArrearCount: {
                          ...roleFormData.historyArrearCount,
                          count: 0,
                        },
                        arrearCount: {
                          ...roleFormData.arrearCount,
                          count: 0,
                        },
                      })
                      setPreviewData({
                        ...previewData,
                        isHistoryArrears: false,
                        isArrearsAllowed: false,
                        historyArrearCount: 0,
                        arrearCount: 0,
                      })
                      roleForm.setFieldValue(['isHistoryArrears'], false)
                      roleForm.setFieldValue(['historyArrearCount', 'count'], 0)

                      roleForm.setFieldValue(
                        ['isArrearsAllowed'],
                        event.target.checked
                      )
                      roleForm.setFieldValue(['arrearCount', 'count'], 0)
                    }
                    //  onChangeHandlerCTC(event.target.checked, 'isBond')
                  }
                  label={'No arrears allowed'}
                  checked={
                    !roleFormData?.isHistoryArrears &&
                    !roleFormData?.isArrearsAllowed
                  }
                  disabled={isReturnBoolean(
                    roleFormData?.roleStatus,
                    undefined,
                    roleFormData?.republishedDate
                  )}
                />
              </FormItem>
              <ArrearSubText>
                No current or history of arrears allowed
              </ArrearSubText>
            </MarginDiv>
          </div>
        </>
      )}
      <ScoreDrawer
        openScoreDrawer={openScoreDrawer}
        setOpenScoreDrawer={setOpenScoreDrawer}
        marksValue={marksValue}
        setMarksValue={setMarksValue}
        roleFormData={roleFormData}
        setRoleFormData={setRoleFormData}
        setScoreError={setScoreError}
        singleRoleData={singleRoleData}
        isEditingRole={isEditingRole}
        isEditRoleOnView={roleFormData?.republishedDate ?? false}
      />
    </>
  )
}

export default EligibilityCriteria
